<template>
  <div class="h-dialogContainer">

    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.taskName')}}:</div>
          <input class="e-control e-textbox e-lib e-input" type="text" disabled="disabled" v-model="paramsOfDetailDialog.sysMeterTaskName">
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.resourceType')}}:</div>
          <input class="e-control e-textbox e-lib e-input" type="text" disabled="disabled" v-model="neTypeId">
        </div>
      </div>
    </div>

    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.measureCycle')}}:</div>
          <input class="e-control e-textbox e-lib e-input" type="text" disabled="disabled" v-model="paramsOfDetailDialog.meterTimePeriod">
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.timeMode')}}:</div>
          <input class="e-control e-textbox e-lib e-input" type="text" disabled="disabled" v-model="paramsOfDetailDialog.effectiveTimeMode">
        </div>
      </div>
    </div>

    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.start_time')}}:</div>
          <input class="e-control e-textbox e-lib e-input" type="text" disabled="disabled" v-model="paramsOfDetailDialog.meterBegTime">
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.end_time')}}:</div>
          <input class="e-control e-textbox e-lib e-input" type="text" disabled="disabled" v-model="paramsOfDetailDialog.meterEndTime">
        </div>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.taskDescription')}}:</div>
          <input class="e-control e-textbox e-lib e-input" type="text" disabled="disabled" v-model="paramsOfDetailDialog.sysMeterTaskDepict">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 control-section h100-40 h-scroll">
        <div class='content-wapper h100' >
          <ejs-treegrid :dataSource='dataOfDetail' idMapping='id' parentIdMapping='parentItem' hasChildMapping='isParent' :treeColumnIndex='0' :enableHover="true">
            <e-columns>
              <e-column field='neName' :headerText='$t("Pm.resource_name")' width='24%' clipMode='EllipsisWithTooltip'></e-column>
              <e-column field='measureTypeName' :headerText='$t("Pm.measurementObjectClassify")' textAlign='Center' width='24%' clipMode='EllipsisWithTooltip'></e-column>
              <e-column field='measureObjectName' :headerText='$t("Pm.measureObjName")' textAlign='Center' width='27%' clipMode='EllipsisWithTooltip'></e-column>
              <e-column field='meterStatus' :headerText='$t("Pm.taskState")' textAlign='Center' width='25%' :disableHtmlEncode='false' :formatter="formatterOfDetailStatus" clipMode='EllipsisWithTooltip'></e-column>
            </e-columns>
          </ejs-treegrid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ShowDetailDialog',
  props: [
    'paramsOfDetail',
    'neTypeId'
  ],
  components: {
  },
  data() {
    return {
      dataOfDetail: [{}],
      paramsOfDetailDialog: {
        sysMeterTaskName: '',
        meterTimePeriod: '',
        effectiveTimeMode: '',
        meterBegTime: '',
        meterEndTime: '',
        sysMeterTaskDepict: '',
      },
      detailStatus: new Map()
        .set('0', this.$t('Pm.hangup'))
        .set('1', this.$t('Pm.active'))
        .set('2', this.$t('Pm.failure'))
        .set('3', ''),
    };
  },
  methods: {
    formatterOfDetailStatus(grids, data) {
      let color = '';
      switch (data.meterStatus) {
        case '0':
          color = 'red';
          break;
        case '1':
          color = 'green';
          break;
        case '2':
          color = 'gray';
          break;
        default:
          break;
      }
      return `<span style='background-color:${color};font-size: 12px;display: inline-block;width: 55px;height: 22px;color: #fff;line-height: 22px;' >${this.detailStatus.get(data.meterStatus)}</span>`;
    }
  },
  watch: {
    'paramsOfDetail'(paramsOfDetail) {
      this.paramsOfDetailDialog = paramsOfDetail;
    },
    'neTypeId'(neTypeId) {
      this.neTypeId = neTypeId;
    }
  }
};
</script>

<style>
  .h-dialogContainer .h-borderBox {
    border: 1px solid #d9d9d9;
    border-radius: 3px;
  }
</style>
